module.exports = __webpack_public_path__ + "img/cl1.5987e5a9.png";